import React, { useState } from 'react';
import Skeleton from '@material-ui/lab/Skeleton';

const Skltn = () => {
    return (
        <div className="innerWebinar skltn-lotterycard">
            <div className="contain">
                <div className="inner-body">
                    <div className="backward">
                        <span>بازگشت <i className="icon-arrow-down-sign-to-navigate-fill"></i></span>
                    </div>
                    <div className="body">
                        <h6>
                            <Skeleton animation="wave" width={60 + "%"} height={28} />
                        </h6>
                        <div className="picture">
                            <Skeleton animation="wave" width={100 + "%"} height={400} />
                        </div>
                        <div className="time">
                            <span>تاریخ شروع: <b><Skeleton animation="wave" width={120} height={28} /></b></span>
                            <span>زمان برگزاری: <b><Skeleton animation="wave" width={120} height={28} /></b></span>
                        </div>
                        <span className="about">درباره وبینار : </span>
                        <p>
                            <Skeleton animation="wave" width={30 + "%"} height={22} />
                            <Skeleton animation="wave" width={40 + "%"} height={22} />
                            <Skeleton animation="wave" width={50 + "%"} height={22} />
                            <Skeleton animation="wave" width={60 + "%"} height={22} />
                        </p>
                        <div className="btn">
                            <Skeleton animation="wave" width={150} height={34} />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Skltn;